module.exports = __webpack_public_path__ + "img/fountain.f5b72fbc.jpg";